import { render, staticRenderFns } from "./OffersShow.vue?vue&type=template&id=21c44312&scoped=true&"
import script from "./OffersShow.vue?vue&type=script&lang=js&"
export * from "./OffersShow.vue?vue&type=script&lang=js&"
import style0 from "./OffersShow.vue?vue&type=style&index=0&id=21c44312&scoped=true&lang=scss&"
import style1 from "./OffersShow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c44312",
  null
  
)

export default component.exports